import cookiesStatement from './cookies-statement'
import partnerAgreement from './partner-agreement'
import privacyPolicy from './privacy-policy'
import withdrawalAgreement from './withdrawal-agreement'

export const MAIN_DOCUMENT = 'partnerAgreement'

const documents = {
  [MAIN_DOCUMENT]: partnerAgreement,
  cookiesStatement,
  privacyPolicy,
  withdrawalAgreement
}

export default documents
